import { injectHtml } from "utils/htmlUtil";
import http from "services/httpService";
import { catchError } from "utils/errorUtil";
import forms from "components/common/forms"
import { openSnackbar, snackbarModel } from "components/common/snackbar";

const props = {
    adminAboutUsMarker: ".marker-about-us-management-edit",
    modalPlaceholder: '#popup-placeholder',
    editSectionModuleModal: "#about-us-section-modal",
    editSectionModuleModalId: "about-us-section-modal",
    addSectionModuleButton: "#add-section-module",
    sectionModuleForm: "#about-us-section-form",
    submitSectionModuleButton: "#submit-about-us-section-form",
    sectionModuleWrapper: '.section-module-wrapper',
    editorMarker: '.editor-marker'
};

//! PUBLIC FUNCTIONS
export function initAdminAboutUsManagement() {
    if (!$(props.adminAboutUsMarker).length) return;

    bindAddSectionModule();
    bindEditSectionModule();

    //this is necessary to stop tinymce functions (such as source code) being 'readonly' if launched within a bootstrap modal.
    //source: https://www.tiny.cloud/docs/integrations/bootstrap/
    $(document).on('focusin', function (e) {
        if ($(e.target).closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root").length) {
            e.stopImmediatePropagation();
        }
    });
}


function bindAddSectionModule() {

    $(props.addSectionModuleButton).off("click").on("click", function () {

        initLoadModuleModal(null);
    });
}


function bindEditSectionModule() {

    $(props.sectionModuleWrapper).off("click").on("click", function () {

        var id = $(this).data('id');

        initLoadModuleModal(id);
    });
}


async function initLoadModuleModal(id) {

    const data = {
        id: id
    };

    const result = await getAboutUsModuleModalHtml(data);

    await injectHtml(props.modalPlaceholder, result);

    //bind 'modal on shown' events
    await initLoadModuleModalOnShow();

    //launch modal
    $(props.editSectionModuleModal).modal('show');
}


function initLoadModuleModalOnShow() {

    catchError(async function () {

        //when the modal is shown bind all relevant events
        $(props.editSectionModuleModal).off('shown.bs.modal').on('shown.bs.modal', async function (e) {

            //init standard mdc elements
            window.mdc.autoInit(document.getElementById(props.editSectionModuleModalId));

            initTinyMce();

            //bind submit event
            initSubmitAboutModuleChangeEvents();

        })
    });
}


function initSubmitAboutModuleChangeEvents() {

    //TODO: add reason for try catch
    catchError(async function () {

        const formObject = $(props.sectionModuleForm);
        const save_button_selector = $(props.submitSectionModuleButton);

        //only attempt validation / binding if the form is present
        if (formObject.length > 0) {

            //initialise jquery validation for the injected form
            const validator = forms.onloadValidationSetupByObject(formObject);

            $(save_button_selector).off('click').on('click', async function () {

                //validate form
                if (formObject.valid()) {

                    const parent = $(props.editDeliveryAddressModal);

                    const activityIndicator = parent.find('.submit-activity');

                    activityIndicator.show().css("display", "inline-block");

                    forms.formUnderSubmission(true);

                    setTimeout(async function () {

                        formObject.submit();

                    }, 1000);
                } else {

                    //no scroll to in modal
                    //app.forms.scrollToFirstError(validator, $(document).height() * 0.5);
                }
            });
        }
    });
}

function initTinyMce() {

    tinymce.remove(props.editorMarker);

    tinymce.init({
        selector: props.editorMarker,
        plugins:
            'advlist anchor autolink charmap code codesample fullscreen image link lists paste searchreplace table help',
        toolbar:
            'bold italic underline forecolor | ' +
            'bullist numlist | fullscreen | ' +
            'link codesample charmap | ' +
            'alignleft aligncenter alignright alignjustify ' +
            'help',
        menu: {
            file: {
                title: 'File',
                items: ''
            },
            edit: {
                title: 'Edit',
                items: 'undo redo | cut copy paste pastetext | selectall | searchreplace'
            },
            view: {
                title: 'View',
                items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments'
            },
            insert: {
                title: 'Insert',
                items: 'image link media addcomment pageembed template codesample inserttable | charmap hr | pagebreak nonbreaking anchor toc | insertdatetime'
            },
            format: {
                title: 'Format',
                items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats align | forecolor | removeformat'
            },
            tools: {
                title: 'Tools',
                items: ''
            },
            help: {
                title: 'Help',
                items: 'help'
            }
        },
        force_p_newlines: false,
        forced_root_block: '',
        //For more styles use content_css (see the docs)
        content_style: "body { font-size: 14px; }",
        height: 480
    });
}



//API CALLS

async function getAboutUsModuleModalHtml(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/contentmanagement/editaboutusmodule', data);

    // The response is an object with a property called 'data'. This contains the modal HTML.
    return response.data;
}
